import { MerchantGroupDto } from "./merchantGroup.dto";

export class PaymentMethodDto {
  id: number;
  description: string;
  code: string;
  isCash: boolean;
  isCard: boolean;
  providerCode?: string;
  processingFee?: number;
  cardProcessingFee?: number;
  refundProcessingFee?: number;
  isWebOrdering?: boolean;
  isWebKiosk?: boolean;
  isWebPOS?: boolean;
  isIntegration?: boolean;
  isOtherPayment?: boolean;
  isHouseAccount?: boolean;
  isDepositPayment?: boolean;
  isWebGiftCards?: boolean;
  isGiftCard: boolean;
  merchantGroups?: MerchantGroupDto[];
  isBank?: boolean;
  isInvoicing?: boolean;
}
